const DefendSlogan = () => {
  return (
    <div className="py-[46px] text-center">
      <h11 className="font-[Rockwell] 2xl:text-[50px] xl:text-[40px] lg:text-[35px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold">
        HEAVY-DUTY 4WD UTILITY VEHICLES BUILT FOR WORK
      </h11>
      <p className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
        Tuatara UTVs deliver the power, durability, and reliability you need to get more done. Our heavy-duty 4WD utility vehicles are engineered for agriculture, construction, and commercial use – combining high payload capacity, all-terrain performance, and tough steel construction.
      </p>
      <p className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
        Explore the Tuatara range and discover why more operators across the USA are choosing a UTV built to work harder, last longer, and perform when it matters most.
      </p>
    </div>
  );
};
export default DefendSlogan;
